/**
 * Passagem de contexto entre telas — uma posição, consumida por quem chega.
 *
 * O roteador da casca só carrega a seção; não há parâmetro de rota, e a casca
 * é de outro dono. Quando o Painel diz "abra o número X" ou "veja os
 * suspensos", essa intenção precisa atravessar a troca de tela sem inventar
 * rota nova. Quem chega lê e limpa: recarregar a página não repete a ação.
 */
export interface Passagem {
  numeroId?: string;
  estado?: string;
}

let pendente: { secao: string; dados: Passagem } | null = null;

/**
 * Eco curto do último consumo. O StrictMode do React chama o inicializador de
 * estado duas vezes na montagem; sem o eco, a segunda chamada acharia a caixa
 * já vazia e a tela abriria sem o alvo — bug que só existe em desenvolvimento
 * e some em produção, que é o pior tipo de bug para diagnosticar.
 */
let eco: { secao: string; dados: Passagem; em: number } | null = null;
const JANELA_ECO_MS = 2000;

export function passar(secao: string, dados: Passagem): void {
  pendente = { secao, dados };
  eco = null;
}

export function receber(secao: string): Passagem | null {
  if (pendente && pendente.secao === secao) {
    const { dados } = pendente;
    pendente = null;
    eco = { secao, dados, em: Date.now() };
    return dados;
  }
  if (eco && eco.secao === secao && Date.now() - eco.em < JANELA_ECO_MS) {
    return eco.dados;
  }
  return null;
}

/** A rota do contrato pode vir com caminho; a casca só entende a seção. */
export function secaoDaRota(rota: string): string {
  return rota.replace(/^\/+/, "").split(/[/?#]/)[0] ?? "painel";
}
